export default __webpack_public_path__ + "static/media/done-black.0eaa8129.svg";